export default __webpack_public_path__ + "static/media/ed4.a2d05ada.jpg";